module.exports = __webpack_public_path__ + "img/2.22669723.png";